import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { selectToken } from '../../../util/tokenSelector.js';
import { Box } from '../../Box/Box.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';
import { DotLoaderStyled } from './Dots.styled.js';

var _excluded = ["variant", "label", "live"];
var DOTS_COUNT = 5;
var getDotColorToken = function getDotColorToken(variant, index) {
  switch (variant) {
    case 'primary':
      return 'deprecated.primary.brand';
    case 'background':
      return 'base.surface.floating.inverted';
    case 'secondary':
      return 'base.surface';
    default:
      return "brand.".concat(index + 1);
  }
};
var range = function range(start, end) {
  var length = end - start;
  return Array.from({
    length: length
  }, function (_, i) {
    return start + i;
  });
};
var DotsLoader = function DotsLoader(_ref) {
  var variant = _ref.variant,
    label = _ref.label,
    live = _ref.live,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useThemeContext();
  var dots = range(0, DOTS_COUNT).map(function (index) {
    var _selectToken;
    var dotColorToken = getDotColorToken(variant, index);
    var dotColor = (_selectToken = selectToken(theme.background, dotColorToken)) !== null && _selectToken !== void 0 ? _selectToken : theme.background['deprecated.primary.brand'];
    return /*#__PURE__*/React.createElement(DotLoaderStyled, {
      key: index,
      index: index,
      dotColor: dotColor,
      display: "inline-block",
      alignSelf: "flex-end",
      ms: index === 0 ? undefined : '4',
      height: "6px",
      width: "6px",
      borderRadius: "max"
    });
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "alert",
    "aria-live": live,
    "aria-label": label
  }, rest, {
    display: "flex",
    mx: "auto",
    my: "4"
  }), dots);
};
DotsLoader.defaultProps = {
  live: 'assertive'
};
DotsLoader.displayName = 'DotsLoader';

export { DotsLoader, range };
//# sourceMappingURL=Dots.js.map
